import { render, staticRenderFns } from "./Receptionist.vue?vue&type=template&id=63f516d2"
import script from "./Receptionist.vue?vue&type=script&lang=js"
export * from "./Receptionist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports